// extracted by mini-css-extract-plugin
export default {"card":"nL-z","defaultCard":"oL-z","cardDetails":"pL-z","cardActions":"qL-z","separator":"rL-z"};